import { Stack } from '@mui/material';
import { DialogProps } from '../../../interfaces/interfaces';
import { CustomerClient } from '../../../helpers/client';
import { Popup } from '../../popup/popup';
import { AccountConfirmButton } from './accountSettingsStyles';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../redux/hooks';
import { forceLoginAgain, logout } from '../../../redux/reducers/authReducer';
import { appStyleMode } from '../../../helpers/clientConfigs';
import { AppStyle } from '../../../helpers/appStyle';

export function CustomerDelete(props: DialogProps) {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { onClose, open } = props;
  const customersClient: CustomerClient = new CustomerClient();

  const removeUser = () => {
    customersClient
      .delete()
      .then(async () => {
        if (appStyleMode === AppStyle.Mobile) {
          dispatch(forceLoginAgain());
        } else {
          dispatch(logout());
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <Popup
      open={open}
      onClose={onClose}
      dialogTitle={t('account:deleteAccountConfirmation')}
      dialogActions={
        <Stack direction="row" justifyContent="space-evenly" alignItems="center" sx={{ width: '100%' }}>
          <AccountConfirmButton onClick={() => onClose()} variant="contained">
            {t('account:confirmationNo')}
          </AccountConfirmButton>
          <AccountConfirmButton onClick={() => removeUser()} variant="contained">
            {' '}
            {t('account:confirmationYes')}
          </AccountConfirmButton>
        </Stack>
      }
    />
  );
}
